import React from "react";

// Background + Member Images
import bgTeam from "../../../images/bg/team-bg.png";
import noiseBg from "../../../images/team/noice-bg.png";

import img01 from "../../../images/team/person1.jpg";
import img02 from "../../../images/team/person2.jpg";
import img03 from "../../../images/team/person3.jpg";
import img04 from "../../../images/team/person4.jpg";
import img05 from "../../../images/team/person5.jpg";
import img06 from "../../../images/team/person6.jpg";
import img07 from "../../../images/team/person7.jpg";
import img08 from "../../../images/team/person8.jpg";

const teamMembers = [
  { name: "Ana Rivera", role: "Support Lead", img: img01 },
  { name: "Priya Shah", role: "API Engineer", img: img02 },
  { name: "Aiden Brooks", role: "Reseller Manager", img: img03 },
  { name: "Grayson Cole", role: "Fraud & Safety", img: img04 },
  { name: "Eliana Rose", role: "Billing Support", img: img05 },
  { name: "Carter Vaughn", role: "Night Shift Support", img: img06 },
  { name: "Logan Pierce", role: "Growth Marketer", img: img07 },
  { name: "Emerson Tate", role: "Operations Manager", img: img08 },
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150 bg_img"
      style={{ backgroundImage: `url(${bgTeam})` }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Our Support Team</span>
          <h2 className="title title-line_height">Real people behind the panel</h2>
        </div>

        <div className="row mt-none-55">
          {teamMembers.map((member, i) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-55"
              key={i}
            >
              <div className="xb-team-item xb-border">
                <div className="xb-item--img">
                  <img src={member.img} alt={member.name} />
                </div>

                <div className="xb-item--holder">
                  <div className="xb-item--author">
                    <h2 className="xb-item--name">{member.name}</h2>
                    <span className="xb-item--desig">{member.role}</span>
                  </div>
                </div>

                <div className="xb-bg">
                  <img src={noiseBg} alt="background texture" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
